define('drops/custom/custom',[
    'jquery',
    'lq/drop',
    'lq/style'
], function ($, Drop, Style) {
	'use strict';

	var defaults = {
        data: {
	        style: 'border:1px solid black;'
        }
	};

    function Custom(options) {
        Drop.call(this, $('<div/>'), defaults, options);

        this.$element
	        .addClass('boxToBorderSize')
	        .css({
	            whiteSpace: 'pre-wrap'
	        });

        this.$customStyledElement = $('<div></div>')
	        .appendTo(this.$element);

        Style.renderStyles(this);
    };
    
    Drop.extend(Custom, Drop);

    Custom.typeName = 'Custom';

    Custom.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.renderStyle();
        this.renderDropShadow();
        this.applyPosition();
	};

    Custom.prototype.renderStyle = function () {
        this.$customStyledElement.attr('style', 'width:100%;height:100%;' + this.data.style);
    };

    Custom.prototype.renderDropShadow = function () {
        if (this.data.hasDrop) {
            this.$element
                .css({
                    boxShadow: this.data.dropSize + 'px ' + this.data.dropSize + 'px ' + this.data.dropBlur + 'px #888888'
                });
        }
        else {
            this.$element.css('boxShadow', 'none');
        }
    };

	return Custom;
});
